// moms-harness:anchor v2
// Spec: docs/spec/auth/LOGISPRD-10053-okta-app-access-denied.yaml

import OktaLogin from '@/pages/auth/login/OktaLoadable'
import OktaSignUp from '@/pages/auth/signup/OktaLoadable'
import OktaSignUpComplete from '@/pages/auth/signup/SignupCompleteLoadable'
import Deactivated from '@/pages/auth/deactivated/Loadable'
import OktaAccessDenied from '@/pages/auth/accessDenied/Loadable'
import UserLog from '@/pages/history/userLog/Loadable'
import DownloadLog from '@/pages/history/downloadLog/Loadable'
import DeliveryAreas from '@/pages/master/deliveryAreas'
import InterfaceHistory from '@/pages/history/interfaceHistory'
import InventoryHistory from '@/pages/inventory/inventoryHistory/Loadable'
import InventoryDefectHistory from '@/pages/inventory/inventoryDefectHistory/Loadable'
import StockTransferConfirm from '@/pages/inventory/stockTransferConfirm/Loadable'
import StockLedger from '@/pages/inventory/stockLedger/Loadable'
import InventoryStatus from '@/pages/inventory/inventoryStatus/Loadable'
import SlsInventoryStatus from '@/pages/inventory/slsInventoryStatus/Loadable'
import StockMoveHistory from '@/pages/inventory/stockMoveHistory/Loadable'
import InventoryPriceStatus from '@/pages/inventory/inventoryPriceStatus/Loadable'
import ErpInbound from '@/pages/inbound/erpInbound/Loadable'
import OutboundWaitingStatus from '@/pages/outbound/outboundWaitingStatus'
import OutboundSearchBatch from '@/pages/outbound/outboundSearchBatch'
import OutboundSearchOrder from '@/pages/outbound/outboundSearchOrder'
import OutboundUnallocated from '@/pages/outbound/outboundUnallocated'
import SingleBatchSetting from '@/pages/outbound/singleBatchSetting'
import GeneralOutbound from '@/pages/outbound/generalOutbound/Loadable'
import OutboundEtc from '@/pages/outbound/outboundEtc/Loadable'
import OutboundGI11 from '@/pages/outbound/outboundSchedule/Loadable'
import OutboundGI28 from '@/pages/outbound/outboundSchedule2/Loadable'
import ShipperPage from '@/pages/master/shipper'
import UserManagement from '@/pages/master/userManagement/Loadable'
import CommonCodeManagement from '@/pages/system/commonCode/Loadable'
import MenuManagement from '@/pages/system/menuManagement/Loadable'
import ComboManagement from '@/pages/system/comboManagement/Loadable'
import ScreenManagement from '@/pages/system/screenManagement/Loadable'
import ProductManagement from '@/pages/master/productManagement/Loadable'
import SkuAttributeManagement from '@/pages/master/skuAttributeManagement/Loadable'
import PairOrderSchedule from '@/pages/master/pairOrderSchedule/Loadable'
import GlobalMonitoring from '@/pages/global/monitoring/Loadable'
import GlobalConsolOutbound from '@/pages/global/consolOutbound/Loadable'
import ReturnReceiptInquiry from '@/pages/return/returnReceiptInquiry/Loadable'
import GlobalOrderCollect from '@/pages/global/orderCollect/Loadable'
import AuthManagement from '@/pages/master/authManagement/Loadable'
import SettlementManagementPage from '@/pages/settlement/SettlementManagement/Loadable'
import SettlementManagementDetailPage from '@/pages/settlement/SettlementManagement/detail/Loadable'
import PromotionManagement from '@/pages/settlement/settlementPromotion'
import SettlementPricing from '@/pages/settlement/settlementPricing/Loadable'
import AllInboundStatus from '@/pages/inbound/allInboundStatus/Loadable'
import GeneralInbound from '@/pages/inbound/generalInbound/Loadable'
import ReturnInquiryAll from '@/pages/return/returnInquiryAll/Loadable'
import Rgr02V2 from '@/pages/return/rgr02V2'
import Rgr10V2 from '@/pages/return/rgr10V2/Loadable'
import Rgr11V2 from '@/pages/return/rgr11V2/Loadable'
import Gr02V2 from '@/pages/inbound/gr02V2/Loadable'
import Rgr08V2 from '@/pages/return/rgr08V2/Loadable'
import Rgr04V2 from '@/pages/return/rgr04V2'
import Rgr01V2 from '@/pages/return/rgr01V2'
import Rgr06V2 from '@/pages/return/rgr06V2'
import { withCoMingleReturns } from '@/pages/return/coMingle'
import GpcRateV2 from '@/pages/global/gpc-rateV2'
import InboundWorkV2 from '@/pages/global/inboundWorkV2/Loadable'
import InboundWorkSearch from '@/pages/global/inboundWorkSearch/Loadable'
import AllocationPriorityV2 from '@/pages/outbound/allocationPriorityV2'
import BizestCancelResult from '@/pages/outbound/bizestCancelResult'
import DailyCloseProduct from '@/pages/inventory/dailyCloseProduct/Loadable'
import DailyClose from '@/pages/inventory/dailyClose/Loadable'
import { BoardDetail, BoardForm, BoardList } from '@/pages/report/board/Loadable'

const CoMingleRgr06V2 = withCoMingleReturns(Rgr06V2)
const CoMingleRgr02V2 = withCoMingleReturns(Rgr02V2)

export const ROUTES_WITH_ELEMENTS = {
  // Authorization
  auth: {
    // 로그인 이전 — LOGISPRD-11076: 레거시 id/pw 로그인·회원가입·OTP 화면은 제거됐다.
    // /auth/login 은 Okta 랜딩 자체이고, /auth/okta-login 은 기존 직접 진입 URL 을 위한 별칭이다.
    login: <OktaLogin />,
    'okta-login': <OktaLogin />,
    'okta-signup': <OktaSignUp />, // 신규(Okta) 회원가입
    'okta-signup-complete': <OktaSignUpComplete />, // 신규(Okta) 회원가입 완료
    'okta-access-denied': <OktaAccessDenied />, // Okta 앱 미할당/MOMS 접근 권한 없음
    deactivated: <Deactivated />,
  },
  // Master
  ma: {
    // ma01: <InlineFramePage />,
    // ma02: <InlineFramePage />,
    // ma03: <InlineFramePage />,
    // ma04: <InlineFramePage />,
    // ma05: <InlineFramePage />,
    // sy07: <InlineFramePage />, // 코드관리
    // ma08: <InlineFramePage />,
    // ma09: <InlineFramePage />, // 필드관리
    // ma10: <InlineFramePage />, // 합배송스케쥴
    // ma11 - API 전송 [ 미사용 메뉴 ]
    // ma12 - 브랜드관리 [ 미사용 메뉴 ]
    ma13: <DeliveryAreas />, // 우편번호권역 관리
    ma14: <ShipperPage />, // 화주사 관리
    ma15: <UserManagement />, // 유저관리
    sy10: <CommonCodeManagement />, // 공통코드관리 리뉴얼 (route key placeholder — 실제 메뉴코드 확정 필요, sy07 레거시는 iframe 유지 / SY08=API관리·SY09=캘린더관리 기사용)
    ma16: <AuthManagement />, // 권한관리 리뉴얼 (route key placeholder — 실제 메뉴코드 확정 필요, ma03 레거시는 iframe 유지)
    ma17: <ProductManagement />, // 상품관리 리뉴얼 (route key placeholder — 실제 메뉴코드 확정 필요, ma02 레거시는 iframe 유지)
    // MA18 신규 상품관리 — sku_attribute 축 (LOGISPRD-13286). ma17(master_item)과 원장이 다른 별개 화면이며
    // fade-out 기간 내내 나란히 산다. **이 줄은 라우트만 연다** — 좌측 메뉴는 1.0 메뉴 테이블이 그리므로
    // MA18 행을 등록하기 전까지 사이드바에 나타나지 않는다 (URL 직접 진입은 가능. 데이터는 BE 인가가 막는다)
    ma18: <SkuAttributeManagement />,
    // MA19 합배송스케쥴 — 1.0 MA10 의 2.0 이관(TM-4166). ma10 은 iframe 으로 남는다. 메뉴 테이블은 dev 만 등록(MENU_ORD 0-8-1, 권한은 MA10 복제), prod 미등록
    ma19: <PairOrderSchedule />,
  },
  gr: {
    //   gr01: <InlineFramePage />,
    //   gr02: <InlineFramePage />,
    //   gr03: <InlineFramePage />,
    //   gr04: <InlineFramePage />,
    //   gr05: <InlineFramePage />,
    //   gr06: <InlineFramePage />,
    //   egr01: <InlineFramePage />,
    // 입고조회(전체) — 1.0 GR05 를 신규 디자인(pbo-core)으로 재구현한 화면 (LOGISPRD-11235).
    // 기존 gr05 는 1.0(iframe) 그대로 두고 미사용 다음 번호 GR08 을 새 URL 로 쓴다(GR01→gr07·ST10·EST04 선례).
    // route key placeholder — 실제 메뉴코드는 확정 필요.
    gr08: <AllInboundStatus />,
    // 일반입고 — 1.0 GR01 을 신규 디자인(pbo-core)으로 재구현한 화면 (LOGISPRD-11242).
    // 기존 gr01 은 1.0(iframe) 그대로 두고 미사용 다음 번호 GR07 을 새 URL 로 쓴다(ST10·EST04 선례).
    gr07: <GeneralInbound />,
    // 일반입고(ERP) — 1.0 EGR01 을 신규 디자인(pbo-core)으로 재구현한 화면 (LOGISPRD-11243).
    // 기존 egr01 은 1.0(iframe) 그대로 두고 미사용 다음 번호 EGR06 을 새 URL 로 쓴다(ST10·EST04 선례).
    egr06: <ErpInbound />,
    // 입고조회 2.0 — 1.0 GR02 를 신규 디자인(pbo-core)으로 재구현한 화면(LOGISPRD-12099). gr02 레거시는 iframe 유지.
    // 메뉴코드 GR09('입고조회 2.0', MENU_ORD=1-3-1) 로 확정됐다(rgr13 선례).
    // dev DB 등록 완료 — MOMS_MENU_INFO(MENU_ORD=1-3-1) · MOMS_AUTH_INFO(GR02 권한 379행 복제). prod 등록은 아직이다.
    gr09: <Gr02V2 />, // 컨덕터 핸드오프
  },
  rgr: {
    //   rgr01: <InlineFramePage />,
    //   rgr02: <InlineFramePage />,
    //   rgr03: <InlineFramePage />,
    //   rgr04: <InlineFramePage />,
    //   rgr05: <InlineFramePage />,
    //   rgr06: <InlineFramePage />,
    //   rgr07: <InlineFramePage />,
    //   rgr08: <InlineFramePage />,
    //   rgr09: <InlineFramePage />,
    //   rgr10: <InlineFramePage />,
    //   rgr11: <InlineFramePage />,
    // 메뉴명 "센터도착 수령내역 조회 2.0" — rgr09 레거시는 iframe 그대로 두고 새 코드로 붙인다.
    // 좌측 메뉴 노출은 DB(MOMS_MENU_INFO·MOMS_AUTH_INFO) 등록이 필요하다(rgr09 권한 매트릭스 복제).
    // route key 는 placeholder — 메뉴코드 확정 시 함께 맞춘다.
    rgr12: <ReturnReceiptInquiry />,
    // 반품조회(전체) — 1.0 RGR05 를 신규 디자인(pbo-core)으로 재구현한 화면 (LOGISPRD-11237).
    // 기존 rgr05 는 1.0(iframe) 그대로 두고 다음 미사용 번호 RGR13 을 새 URL 로 쓴다(rgr12 선례).
    // dev DB 등록 완료 — MOMS_MENU_INFO(MENU_ORD=2-5-1) · MOMS_AUTH_INFO(RGR05 권한 379행 복제).
    rgr13: <ReturnInquiryAll />,
    // 반품조회 2.0 — rgr02 레거시는 iframe 유지. route key 는 placeholder(실제 메뉴코드 확정 필요).
    // 좌측 메뉴 노출은 DB(MOMS_MENU_INFO·MOMS_AUTH_INFO) 등록 필요(레거시 권한 매트릭스 복제).
    rgr20: <CoMingleRgr02V2 />, // 컨덕터 핸드오프
    // 반품모니터링 2.0 — rgr10 레거시는 iframe 유지.
    // dev DB 등록 완료 — MOMS_MENU_INFO(MENU_ORD=2-10-1) · MOMS_AUTH_INFO(RGR10 권한 379행 복제). prod 미등록.
    rgr19: <Rgr10V2 />, // 컨덕터 핸드오프
    // 반품작업_신규 2.0 — rgr11 레거시는 iframe 유지. 메뉴코드 RGR18 확정(MENU_ORD=2-11-1).
    // dev DB 등록 완료 — MOMS_MENU_INFO(MENU_ORD=2-11-1) · MOMS_AUTH_INFO(RGR11 권한 379행 복제). prod 미등록.
    // qz-tray·jsrsasign 까지 붙는 화면이라 Loadable 경유로 청크를 분리한다(ReturnReceiptInquiry·
    // AllInboundStatus 선례, PR #691 리뷰 코멘트).
    rgr18: <Rgr11V2 />, // 컨덕터 핸드오프
    // 센터도착 수령작업 2.0 — 1.0 RGR08 을 신규 디자인(pbo-core)으로 재구현한 화면 (LOGISPRD-12100).
    // 기존 rgr08 은 1.0(iframe) 그대로 두고 확정된 메뉴코드 RGR14 를 새 URL 로 쓴다(rgr12·rgr13 선례).
    // dev DB 등록 완료 — MOMS_MENU_INFO(MENU_ORD=2-8-1) · MOMS_AUTH_INFO(RGR08 권한 379행 복제). prod 미등록.
    rgr14: <Rgr08V2 />, // 컨덕터 핸드오프
    // 반품관리 2.0 — rgr04 레거시는 iframe 유지. 메뉴코드 RGR15('반품관리 2.0', MENU_ORD=2-4-1) 확정.
    // dev DB 등록 완료 — MOMS_MENU_INFO·MOMS_AUTH_INFO(RGR04 권한 380행 복제). prod 미등록.
    rgr15: <Rgr04V2 />, // 컨덕터 핸드오프
    // 반품입고 2.0 — rgr01 레거시는 iframe 유지. route key 는 placeholder(실제 메뉴코드 확정 필요).
    // 좌측 메뉴 노출은 DB(MOMS_MENU_INFO·MOMS_AUTH_INFO) 등록 필요(레거시 권한 매트릭스 복제).
    rgr16: <Rgr01V2 />, // 컨덕터 핸드오프
    // 반품작업 2.0 — rgr06 레거시는 iframe 유지. 신규 메뉴코드 RGR17 확정.
    // dev DB 등록 완료 — MOMS_MENU_INFO(MENU_ORD=2-6-1) · MOMS_AUTH_INFO(RGR06 권한 379행 복제). prod 미등록.
    rgr17: <CoMingleRgr06V2 />, // 컨덕터 핸드오프
  },
  gi: {
    //   gi01: <InlineFramePage />,
    //   gi02: <InlineFramePage />,
    //   gi03: <InlineFramePage />,
    //   gi04: <InlineFramePage />,
    //   gi05: <InlineFramePage />,
    //   gi06: <InlineFramePage />,
    //   gi07: <InlineFramePage />,
    //   gi08: <InlineFramePage />,
    //   gi11: <InlineFramePage />,
    //   gi12: <InlineFramePage />,
    //   gi13: <InlineFramePage />,
    //   gi14: <InlineFramePage />,
    //   gi15: <InlineFramePage />,
    //   gi16: <InlineFramePage />,
    //   gi17: <InlineFramePage />,
    //   gi19: <InlineFramePage />,
    //   gi20: <InlineFramePage />,
    //   gi22: <InlineFramePage />,
    gi23: <OutboundWaitingStatus />,
    gi24: <OutboundSearchBatch />,
    gi25: <OutboundSearchOrder />,
    gi26: <OutboundUnallocated />,
    gi36: <SingleBatchSetting />,
    // 기타출고 — 1.0 GI35 를 신규 디자인(pbo-core)으로 재구현한 화면 (LOGISPRD-11239).
    // 기존 gi35 는 1.0(iframe) 그대로 두고 신규 메뉴코드 GI38 을 새 URL 로 쓴다(st10·est04 선례).
    gi38: <OutboundEtc />,
    //   ts01: <InlineFramePage />,
    gi27: <OutboundGI11 />,
    gi28: <OutboundGI28 />,
    // 일반출고 — 1.0 GI31 을 신규 디자인(pbo-core)으로 재구현한 화면 (LOGISPRD-11238).
    // 기존 gi31 은 1.0(iframe) 그대로 두고 미사용 다음 번호 GI37 을 새 URL 로 쓴다(st10·est04 선례).
    gi37: <GeneralOutbound />,
    // 할당우선순위 2.0 — allocation-priority 레거시는 iframe 유지. route key 는 placeholder(실제 메뉴코드 확정 필요).
    // 좌측 메뉴 노출은 DB(MOMS_MENU_INFO·MOMS_AUTH_INFO) 등록 필요(레거시 권한 매트릭스 복제).
    gi39: <AllocationPriorityV2 />, // 컨덕터 핸드오프
    // 출고취소(비제스트) 2.0 — 1.0 GI17 을 pbo-conductor 로 이관한 화면 (LOGISPRD-16035).
    // gi17 은 1.0(iframe) 그대로 두고 새 메뉴코드 GI40 으로 나란히 올린다. 좌측 메뉴 노출은 MOMS_MENU_INFO·MOMS_AUTH_INFO 등록 필요.
    gi40: <BizestCancelResult />,
  },
  st: {
    //   st01: <InlineFramePage />,
    //   st02: <InlineFramePage />,
    //   st03: <InlineFramePage />,
    //   st04: <InlineFramePage />,
    //   st05: <InlineFramePage />,
    //   st07: <InlineFramePage />,
    //   est01: <InlineFramePage />,
    //   est02: <InlineFramePage />,
    //   est03: <InlineFramePage />,
    // 재고현황 — 1.0 ST02 를 신규 디자인으로 재구현한 화면. 기존 st02 는 1.0(iframe) 그대로 두고
    // 미사용 번호 중 다음 값(st09)을 새 URL 로 쓴다 (route key placeholder — 실제 메뉴코드 확정 필요)
    st09: <InventoryStatus />,
    // 재고이동확정 — 1.0 EST01 을 신규 디자인(pbo-core)으로 재구현한 화면 (LOGISPRD-10670).
    // 기존 est01 은 1.0(iframe) 그대로 두고, 미사용 다음 번호 EST04 를 새 URL 로 쓴다(ST10·ST11 선례).
    est04: <StockTransferConfirm />,
    // 재고수불 — 1.0 ST03 을 신규 디자인(pbo-core)으로 재구현한 화면 (LOGISPRD-10666).
    // 기존 st03 은 1.0(iframe) 그대로 두고 신규 메뉴코드 ST10 을 새 URL 로 쓴다.
    st10: <StockLedger />,
    // 재고이동내역조회 — 1.0 EST03 을 신규 디자인(pbo-core)으로 재구현한 화면 (LOGISPRD-10669).
    // 기존 est03 은 1.0(iframe) 그대로 두고 신규 메뉴코드 EST05 를 새 URL 로 쓴다(est04 는 타 메뉴 사용 중 — ST11 선례).
    est05: <StockMoveHistory />,
    // 재고현황(단가) — 1.0 ST07 을 신규 디자인(pbo-core)으로 재구현한 화면 (LOGISPRD-10668).
    // 기존 st07 은 1.0(iframe) 그대로 두고 신규 메뉴코드 ST11 을 새 URL 로 쓴다(ST10 선례).
    st11: <InventoryPriceStatus />,
    // 재고현황(SLS) — 1.0 대응 화면이 없는 신규 운영 진단 도구 (LOGISPRD-12147).
    // 다른 2.0 화면과 달리 placeholder 가 아니다 — 메뉴코드 ST06 으로 dev DB 메뉴·권한 등록이 끝났다
    // (MENU_TREE=ST, MENU_ORD=4-5-1 → ST02 재고현황 바로 아래. 권한은 ST02 활성 권한 전량 복제).
    st06: <SlsInventoryStatus />,
  },
  iv: {
    // iv01 - 수불관리 [ 미사용 메뉴 ]
    iv02: <InventoryHistory />, // 재고수불내역
    iv03: <InventoryDefectHistory />, // 불량수불내역
  },
  bl: {
    //   bl01: <SettlementCutOff />, // 마감관리
    //   rp03: <SettlementEntry />, // 정산입력
    //   rp04: <SettlementStatus />, // 정산조회
    //   rp05: <ShipmentStatus />, // 운송조회

    bl02: <PromotionManagement />, // MFS 정산관리
    bl03: <SettlementManagementPage />, // MFS 정산관리
    'bl03/:id': <SettlementManagementDetailPage />, // MFS 정산관리 상세
    bl04: <SettlementPricing />, // MFS 단가관리
  },
  // 일마감조회(상품별) 2.0 — RP02 레거시는 최종 iframe 캐치올로 유지하고 신규 메뉴코드 RP12로 연다.
  // 일마감조회 2.0 — RP09 레거시는 최종 iframe 캐치올로 유지하고 신규 메뉴코드 RP13으로 연다.
  // 게시판 2.0 — TS05 레거시는 최종 iframe 캐치올로 유지하고 신규 메뉴코드 RP14로 연다(병행 운용, LOGISPRD-15070).
  rp: {
    rp12: <DailyCloseProduct />,
    rp13: <DailyClose />,
    rp14: <BoardList />,
    'rp14/new': <BoardForm />,
    'rp14/:id': <BoardDetail />,
    'rp14/:id/edit': <BoardForm />,
  },
  // rp: {
  //   rp01: <InlineFramePage />,
  //   rp02: <InlineFramePage />,
  //   rp07: <InlineFramePage />,
  //   rp09: <InlineFramePage />,
  //   ts05: <InlineFramePage />,
  //   erp09: <InlineFramePage />,
  //   rp10: <InlineFramePage />,
  //   rp11: <InlineFramePage />,
  // },
  // sy11·sy12·sy13 외 sy0x 는 path="*" 로 1.0 iframe 유지
  sy: {
    // sy01: <InlineFramePage />,
    // sy02: <InlineFramePage />,
    // sy03: <InlineFramePage />,
    // sy04: <InlineFramePage />,
    // sy05: <InlineFramePage />,
    // sy06: <InlineFramePage />,
    // sy08: <InlineFramePage />,
    // sy09: <InlineFramePage />,
    sy11: <MenuManagement />, // 메뉴관리 2.0 (LOGISPRD-16042, 신규 메뉴코드 SY11 — 부모 SY. sy02 레거시는 병행 운영 동안 iframe 유지)
    sy12: <ComboManagement />, // 콤보관리 2.0 (LOGISPRD-16045, 신규 메뉴코드 SY12 — 부모 SY. sy05 레거시는 병행 운영 동안 iframe 유지)
    sy13: <ScreenManagement />, // 화면관리 2.0 (LOGISPRD-16043, 신규 메뉴코드 SY13 — 부모 SY. sy03 레거시는 병행 운영 동안 iframe 유지)
  },
  // 이관 완료
  hs: {
    hs01: <UserLog />, // 사용자 로그
    // hs02 - 관리자로그 [ 미사용 메뉴 ]
    hs03: <DownloadLog />, // 다운로드로그
    // hs04 - ERP 자료업로드 [ 미사용 메뉴 ]
    rp06: <InterfaceHistory />, // I/F History
  },
  // tm: {
  //   tm01: <InlineFramePage />,
  //   tm02: <InlineFramePage />,
  //   tm03: <InlineFramePage />,
  // },
  gl: {
    gl13: <GlobalMonitoring />, // 모니터링/CS 리뉴얼 (route key placeholder — 실제 메뉴코드 확정 필요, gl11 레거시는 iframe 유지)
    gl14: <GlobalOrderCollect />, // 주문 수집 2.0 (LOGISPRD-11240, 신규 메뉴코드 GL14 — SY02/MA03(MOMS_MENU_INFO/MOMS_AUTH_INFO) 로 정식 등록 완료, gl02 레거시는 iframe 유지)
    gl15: <GlobalConsolOutbound />, // 합배송출고 2.0 (gl01 레거시는 iframe 유지 — LOGISPRD-11241)
    // GPC 배송비 분담금 단가 관리 2.0 — 신규 화면 (컨덕터 자동 핸드오프).
    // 좌측 메뉴 노출은 DB(MOMS_MENU_INFO·MOMS_AUTH_INFO) 등록 필요.
    // route key 는 placeholder — 실제 메뉴코드 확정 시 교체.
    gl16: <GpcRateV2 />, // 컨덕터 핸드오프
    // 입고작업 2.0 — gl09 레거시는 iframe 유지.
    // dev DB 등록 완료 — MOMS_MENU_INFO(MENU_ORD=11-17) · MOMS_AUTH_INFO(GL09 권한 382행 복제). prod 미등록.
    // qz-tray·jsrsasign·jsbarcode 까지 붙는 화면이라 Loadable 경유로 청크를 분리한다(rgr18 과 같다).
    gl17: <InboundWorkV2 />, // 컨덕터 핸드오프
    // 입고작업조회 2.0(LOGISPRD-16038) — gl10 레거시는 iframe 유지. 전환 때 별도 PR 로 gl10 진입을 막는다(docs/plan/LOGISPRD-16038-16058-gl10.md 3장).
    // 메뉴 등록 전(dev·prod 미등록) — 등록 SQL 은 moms-fe#1139 본문. MOMS_MENU_INFO(MENU_ORD=11-18) · MOMS_AUTH_INFO(GL10 권한 복제).
    // ui-groups 를 처음 쓰는 화면이라 Loadable 경유로 청크를 분리한다.
    gl18: <InboundWorkSearch />, // 컨덕터 MCP
  },
  // gl-legacy: {
  //   gl01: <InlineFramePage />,
  //   gl02: <InlineFramePage />,
  //   gl03: <InlineFramePage />,
  //   gl04: <InlineFramePage />,
  //   gl05: <InlineFramePage />,
  //   gl06: <InlineFramePage />,
  //   gl07: <InlineFramePage />,
  //   gl08: <InlineFramePage />,
  //   gl09: <InlineFramePage />,
  //   gl10: <InlineFramePage />,
  //   gl11: <InlineFramePage />,
  //   gl12: <InlineFramePage />,
  // },
} as const
